import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { MapPin, ExternalLink } from "lucide-react";

const WAY_PIN = L.divIcon({
  className: "",
  html: `<div style="background:#EA731D;width:22px;height:22px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 2px 5px rgba(0,0,0,.4)"><span style="display:block;width:7px;height:7px;background:#fff;border-radius:50%;margin:5px auto"></span></div>`,
  iconSize: [22, 22], iconAnchor: [11, 20],
});

function Resize() {
  const map = useMap();
  useEffect(() => {
    const t = setTimeout(() => map.invalidateSize(), 160);
    return () => clearTimeout(t);
  }, [map]);
  return null;
}

export function GpsWaypoint({ geo, workerName, ts, testid, className = "ml-1" }) {
  if (!geo || typeof geo.lat !== "number" || typeof geo.lng !== "number") return null;
  const { lat, lng } = geo;
  const dt = ts ? new Date(ts) : null;
  const dateStr = dt ? dt.toLocaleDateString("en-GB", { timeZone: "Europe/London", month: "short", day: "numeric", year: "numeric" }) : "";
  const timeStr = dt ? dt.toLocaleTimeString("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit" }) : "";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          title="GPS Waypoint"
          className={`${className} inline-flex items-center align-middle text-brand hover:text-brand-dark`}
        >
          <MapPin className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 p-0 overflow-hidden" data-testid={`${testid}-popover`}>
        <div className="px-3 py-2 border-b border-slate-100">
          <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500">GPS Waypoint</p>
        </div>
        <div className="h-44 w-full">
          <MapContainer
            center={[lat, lng]} zoom={16} style={{ height: "100%", width: "100%" }}
            scrollWheelZoom={true} zoomControl={true} dragging={true} attributionControl={false}
          >
            <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" maxNativeZoom={16} maxZoom={19} />
            <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}" maxNativeZoom={16} maxZoom={19} />
            <Marker position={[lat, lng]} icon={WAY_PIN} />
            <Resize />
          </MapContainer>
        </div>
        <div className="px-3 py-2 space-y-1.5">
          <p className="text-xs text-slate-700" data-testid={`${testid}-caption`}>
            {workerName ? `${workerName} on ` : ""}{dateStr} @ {timeStr}
          </p>
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}
            target="_blank" rel="noreferrer"
            data-testid={`${testid}-open`}
            className="inline-flex items-center gap-1 text-xs font-medium text-brand hover:underline"
          >
            <ExternalLink className="h-3 w-3" /> Open in Google Maps
          </a>
        </div>
      </PopoverContent>
    </Popover>
  );
}
